import { makeStyles, tokens } from '@fluentui/react-components';

export const usePaneStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundColor: tokens.colorNeutralBackground1,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '9px',
    padding: '12px 16px',
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  headerTitle: {
    fontSize: '15px',
    fontWeight: 600,
  },
  headerIcon: {
    width: '20px',
    height: '20px',
    flexShrink: 0,
  },
  headerAction: {
    marginLeft: 'auto',
  },
  body: {
    padding: '10px 14px 16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  hint: {
    fontSize: '11px',
    color: tokens.colorNeutralForeground3,
    lineHeight: 1.4,
  },
  hintWarn: {
    fontSize: '11px',
    color: tokens.colorPaletteDarkOrangeForeground1,
    lineHeight: 1.4,
  },
  footer: {
    marginTop: '4px',
    paddingTop: '10px',
    borderTop: `1px solid ${tokens.colorNeutralStroke2}`,
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
  sectionTitle: {
    fontSize: '12px',
    fontWeight: 600,
    color: tokens.colorNeutralForeground3,
    textTransform: 'uppercase',
    letterSpacing: '0.03em',
    marginTop: '6px',
    paddingBottom: '4px',
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  rows: {
    border: `1px solid ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
    overflow: 'hidden',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: '9px',
    padding: '7px 9px',
    fontSize: '13px',
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  rowLast: {
    borderBottom: '0',
  },
  rowDisabled: {
    backgroundColor: tokens.colorNeutralBackgroundDisabled,
    color: tokens.colorNeutralForegroundDisabled,
  },
  who: {
    flex: 1,
    minWidth: 0,
    overflow: 'hidden',
  },
  whoName: {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  whoEmail: {
    display: 'block',
    fontSize: '11px',
    color: tokens.colorNeutralForeground3,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  editor: {
    border: `1px solid ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusMedium,
    padding: '9px 10px',
    fontSize: '13px',
    lineHeight: 1.5,
    minHeight: '96px',
    maxHeight: '220px',
    overflow: 'auto',
    backgroundColor: tokens.colorNeutralBackground1,
    outline: 'none',
  },
  toolbar: {
    display: 'flex',
    gap: '6px',
    alignItems: 'center',
  },
  count: {
    marginLeft: 'auto',
    fontWeight: 400,
    fontSize: '11px',
    color: tokens.colorNeutralForeground3,
  },
  labelRow: {
    display: 'flex',
    alignItems: 'baseline',
    gap: '8px',
    width: '100%',
  },
});

/** SolarWinds mark used in the pane header. */
export function BrandMark({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <path
        fill="#ff6200"
        d="M95.3,95.1l1.7-.5c12.6-3.5,24.7-8.3,36.7-13.3,11.9-5,23.6-11,33.8-19.3,10.91-8.66,19.13-20.24,23.7-33.4.7-2,2-4.7,2.2-6.8-16.4,22.3-81.6,24.5-81.6,24.5l15.4-14c-44.72.13-88.28,14.22-124.6,40.3,24.56,2.64,47.65,12.96,66,29.5,8.9-2.7,17.9-4.7,26.7-7.1v.1ZM197.4,92.9s-60-4.6-122.4,15.4c8.33,8.69,15.27,18.61,20.6,29.4,32.8-18.3,78.3-41.6,101.8-45v.2ZM99.6,147.2c3.9,9.94,6.43,20.37,7.5,31l57.2-58.8-64.6,27.8h-.1Z"
      />
    </svg>
  );
}
